import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/ic_close.svg'


const _withScopeId = n => (_pushScopeId("data-v-291e9984"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-backdrop"
}
const _hoisted_2 = {
  class: "modal2",
  style: {"width":"900px"}
}
const _hoisted_3 = { class: "modal-header flex-row flex-align-center" }
const _hoisted_4 = {
  key: 0,
  class: "text-center flex-1 modal-header-title"
}
const _hoisted_5 = {
  key: 1,
  class: "text-center flex-1 modal-header-title"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body flex-row flex-wrap" }
const _hoisted_9 = { class: "table table-borderless" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"100px"} }),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "*题目类型:")
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "examType1"
}, " 系统 ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "examType2"
}, " 项目 ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "*考题类型:")
  ])
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1 form-check-label",
  for: "questionType1"
}, " 判断题 ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1 form-check-label",
  for: "questionType2"
}, " 单选题 ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1 form-check-label",
  for: "questionType3"
}, " 多选题 ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "*标题:")
  ])
], -1))
const _hoisted_19 = { class: "mb-1" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "align-top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "答题选项:")
  ])
], -1))
const _hoisted_22 = { class: "mb-1" }
const _hoisted_23 = { style: {"font-family":"黑体"} }
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "align-top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "答案选项:")
  ])
], -1))
const _hoisted_27 = { class: "mb-1" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["id", "value"]
const _hoisted_30 = ["for"]
const _hoisted_31 = { style: {"font-family":"黑体"} }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = ["name", "id", "value"]
const _hoisted_34 = ["for"]
const _hoisted_35 = { style: {"font-family":"黑体"} }
const _hoisted_36 = { class: "mb-1" }
const _hoisted_37 = ["id", "value"]
const _hoisted_38 = ["for"]
const _hoisted_39 = { style: {"font-family":"黑体"} }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", null, "状态:")
  ])
], -1))
const _hoisted_41 = { class: "mb-1 form-switch" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, "*排序:")
], -1))
const _hoisted_43 = { class: "mb-1" }
const _hoisted_44 = { class: "flex-row-center modal-footer2" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.itemData.data.id != undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, "修改"))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, "增加")),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
              class: "modal-header-close"
            }, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("tr", null, [
                _hoisted_11,
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    class: "mb-1",
                    type: "radio",
                    name: "examType",
                    id: "examType1",
                    value: "system",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.itemData.data.examType) = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.itemData.data.examType]
                  ]),
                  _hoisted_12,
                  _withDirectives(_createElementVNode("input", {
                    class: "mb-1",
                    type: "radio",
                    name: "examType",
                    id: "examType2",
                    value: "meal",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.itemData.data.examType) = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.itemData.data.examType]
                  ]),
                  _hoisted_13
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_14,
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    class: "mb-1",
                    type: "radio",
                    name: "questionType",
                    id: "questionType1",
                    value: "trueFalse",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.itemData.data.questionType) = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.itemData.data.questionType]
                  ]),
                  _hoisted_15,
                  _withDirectives(_createElementVNode("input", {
                    class: "mb-1",
                    type: "radio",
                    name: "questionType",
                    id: "questionType2",
                    value: "radio",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.itemData.data.questionType) = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.itemData.data.questionType]
                  ]),
                  _hoisted_16,
                  _withDirectives(_createElementVNode("input", {
                    class: "mb-1",
                    type: "radio",
                    name: "questionType",
                    id: "questionType3",
                    value: "checkbox",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.itemData.data.questionType) = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.itemData.data.questionType]
                  ]),
                  _hoisted_17
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_18,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_19, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.itemData.data.title) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.itemData.data.title]
                    ])
                  ])
                ])
              ]),
              (_ctx.itemData.data.questionType != 'trueFalse')
                ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("td", null, [
                      _createElementVNode("div", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemData.data.optionList, (value, idx) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createElementVNode("span", _hoisted_23, _toDisplayString(idx+1) + "、 ", 1),
                            _withDirectives(_createElementVNode("input", {
                              class: "",
                              style: {"width":"75%"},
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((_ctx.itemData.data.optionList[idx].option) = $event)
                            }, null, 8, _hoisted_24), [
                              [_vModelText, _ctx.itemData.data.optionList[idx].option]
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "mb-1 btn btn-link h-75",
                              onClick: ($event: any) => (_ctx.deleteOption(value.number))
                            }, "删除", 8, _hoisted_25),
                            (idx  == (_ctx.itemData.data.optionList.length - 1))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "btn btn-outline-success h-75",
                                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.addOption && _ctx.addOption(...args)))
                                }, "增加"))
                              : _createCommentVNode("", true)
                          ]))
                        }), 256)),
                        (_ctx.itemData.data.optionList == undefined || _ctx.itemData.data.optionList.length == 0)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-outline-success h-75",
                              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.addOption && _ctx.addOption(...args)))
                            }, "增加"))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _hoisted_26,
                _createElementVNode("td", null, [
                  (_ctx.itemData.data.questionType != 'trueFalse')
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.itemData.data.optionList, (value, idx) => {
                        return (_openBlock(), _createElementBlock("span", _hoisted_27, [
                          (_ctx.itemData.data.questionType =='radio')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "mb-1",
                                  type: "radio",
                                  name: "answer",
                                  id: 'answer' + value.number,
                                  value: value.number,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.answer) = $event))
                                }, null, 8, _hoisted_29), [
                                  [_vModelRadio, _ctx.answer]
                                ]),
                                _createElementVNode("label", {
                                  class: "mb-1 form-check-label",
                                  for: 'answer' + value.number
                                }, [
                                  _createElementVNode("span", _hoisted_31, " " + _toDisplayString(idx+1) + " ", 1)
                                ], 8, _hoisted_30)
                              ]))
                            : (_ctx.itemData.data.questionType =='checkbox')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "mb-1",
                                    type: "checkbox",
                                    name: 'answer' + value.number,
                                    id: 'answer' + value.number,
                                    value: value.number,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.itemData.data.answerList) = $event))
                                  }, null, 8, _hoisted_33), [
                                    [_vModelCheckbox, _ctx.itemData.data.answerList]
                                  ]),
                                  _createElementVNode("label", {
                                    class: "mb-1 form-check-label",
                                    for: 'answer' + value.number
                                  }, [
                                    _createElementVNode("span", _hoisted_35, " " + _toDisplayString(idx+1) + " ", 1)
                                  ], 8, _hoisted_34)
                                ]))
                              : _createCommentVNode("", true)
                        ]))
                      }), 256))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.trueFalseOptionList, (value, idx) => {
                        return (_openBlock(), _createElementBlock("span", _hoisted_36, [
                          _withDirectives(_createElementVNode("input", {
                            class: "mb-1",
                            type: "radio",
                            name: "answer",
                            id: 'answer' + value.number,
                            value: value.number,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.answer) = $event))
                          }, null, 8, _hoisted_37), [
                            [_vModelRadio, _ctx.answer]
                          ]),
                          _createElementVNode("label", {
                            class: "mb-1 form-check-label",
                            for: 'answer' + value.number
                          }, [
                            _createElementVNode("span", _hoisted_39, " " + _toDisplayString(value.option) + " ", 1)
                          ], 8, _hoisted_38)
                        ]))
                      }), 256))
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_40,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_41, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      checked: "",
                      type: "checkbox",
                      role: "switch",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.itemData.data.show) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.itemData.data.show]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_42,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_43, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.itemData.data.sort) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.itemData.data.sort]
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              style: {"width":"120px"},
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
            }, "确定"),
            (_ctx.itemData.data.id != undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45))
              : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _createTextVNode("   "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-secondary",
                    style: {"left":"120px"},
                    onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.confirmAdd && _ctx.confirmAdd(...args)))
                  }, "保存&继续增加")
                ])),
            _createTextVNode("    "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              style: {"width":"120px"},
              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
            }, "关闭")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}